import { FormControl } from '@angular/forms';

export function conditionalValidator(predicate: Function, validator: Function) {
    return ((formControl: FormControl) => {
      if (predicate()) {
        const r = validator(formControl); 
        return r;
      }
      return null;
    });
}
